/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import React from 'react';
import { InputTextStyled } from './styles';
import StripeInput from './StripeInput';

export const InputText = ({
  label,
  name,
  value,
  onChange,
  disabled,
  inputComponent,
  width,
  id,
  autoComplete,
}) => {
  const handleChange = (event) => {
    onChange({
      [name]: inputComponent ? event : event.target.value,
    });
  };

  return (
    <InputTextStyled
      label={label}
      name={name}
      disabled={disabled}
      value={value}
      onChange={handleChange}
      key={name}
      InputProps={
        inputComponent ? {
          inputProps: {
            component: inputComponent,
          },
          inputComponent: StripeInput,
        } : {
          autoComplete,
        }
      }
      variant="outlined"
      InputLabelProps={{ shrink: true }}
      id={id}
      width={width}
      styleFontSize="50px"
    />
  );
};

InputText.defaultProps = {
  label: '',
  name: '',
  disabled: false,
  value: '',
  onChange: () => {},
  inputComponent: null,
  id: '',
  width: 100,
  autoComplete: '',
};

InputText.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  inputComponent: PropTypes.func,
  id: PropTypes.string,
  width: PropTypes.number,
  autoComplete: PropTypes.string,
};
